"use strict";

/**
 * Return a function that returns true iff the document's `path` is equal to
 * `value`. Useful for mongoose's `required` field.
 *
 * @return {Function}
 */

module.exports = function (path, value) {
  return function () {
    return this.get(path) === value;
  };
};